import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import "./newProduct.css";

const NewProduct = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  const [product, setProduct] = useState({
    name: "",
    slug: "",
    stock: "",
    status: "Active",
    image: "",
    price: "",
    category: "",
    subcategory: "",
    brand: "",
    sizes: [],
    colors: [],
    description: "",

    specifications: [],

    isFeatured: false,
    isPopular: false,
    isTrending: false,
    isTopSelling: false,
    isDealsOfDay: false,

    isBanner: false,
    isAd: false,
    isRecentlyAdded: false,
    isTopRated: false,
  });

  // upload image
  const uploadImageToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "SulavSewa");
    data.append("cloud_name", "dknqhkkhy");

    try {
      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dknqhkkhy/image/upload",
        {
          method: "POST",
          body: data,
        },
      );

      const result = await res.json();
      return result.secure_url;
    } catch (err) {
      console.error("Upload failed", err);
      return null;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedProduct = {
      ...product,
      [name]: value,
    };

    // auto slug from name
    if (name === "name") {
      updatedProduct.slug = generateSlug(value);
    }

    setProduct(updatedProduct);
  };

  const handleImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setLoading(true);
      const imageUrl = await uploadImageToCloudinary(file);
      setLoading(false);

      if (imageUrl) {
        setProduct({ ...product, image: imageUrl });
      }
    }
  };

  //SPEC HANDLERS
  const handleSpecChange = (index, field, value) => {
    const updated = [...product.specifications];
    updated[index][field] = value;

    setProduct({ ...product, specifications: updated });
  };

  const addSpecification = () => {
    const last = product.specifications[product.specifications.length - 1];

    if (last && (!last.key.trim() || !last.value.trim())) return;

    setProduct({
      ...product,
      specifications: [...product.specifications, { key: "", value: "" }],
    });
  };

  const removeSpecification = (index) => {
    const updated = product.specifications.filter((_, i) => i !== index);
    setProduct({ ...product, specifications: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!product.name.trim()) return alert("Product name is required");
    if (!product.price) return alert("Price is required");
    if (!product.image) return alert("Please upload image");

    if (product.specifications.length > 0) {
      const hasValidSpec = product.specifications.some(
        (s) => s.key.trim() !== "" && s.value.trim() !== "",
      );

      if (!hasValidSpec) {
        return alert("Please add at least one valid specification");
      }
    }

    const cleanSpecs = product.specifications
      .filter((s) => s.key && s.value && s.key.trim() && s.value.trim())
      .map((s) => ({
        key: s.key.trim(),
        value: s.value.trim(),
      }));

    console.log("PRODUCT SPECS:", product.specifications);
    console.log("CLEAN SPECS:", cleanSpecs);

    if (product.specifications.length > 0 && cleanSpecs.length === 0) {
      alert("Please fill specification fields or remove them");
      return;
    }
    const payload = {
      name: product.name.trim(),
      slug: product.slug,
      image: product.image,
      price: Number(product.price),
      stock: product.stock ? Number(product.stock) : 0,
      category: product.category || "General",
      subcategory: product.subcategory || "",
      brand: product.brand || "",
      sizes: product.sizes || [],
      colors: product.colors || [],
      description: product.description || "",
      status: product.status || "Active",

      specifications: cleanSpecs,

      isFeatured: product.isFeatured,
      isPopular: product.isPopular,
      isTrending: product.isTrending,
      isTopSelling: product.isTopSelling,
      isDealsOfDay: product.isDealsOfDay,
      isBanner: product.isBanner,
      isAd: product.isAd,
      isRecentlyAdded: product.isRecentlyAdded,
      isTopRated: product.isTopRated,
    };

    try {
      const res = await fetch(`${API_URL}/api/products`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("CREATED:", data);

      alert("Product Created Successfully");
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Error creating product");
    }
  };
  return (
    <div className="newProduct">
      <h1 className="addProductTitle">New Product</h1>

      <form className="addProductForm" onSubmit={handleSubmit}>
        {/* IMAGE */}
        <div className="addProductItem">
          <label>Image</label>
          <input type="file" onChange={handleImage} />
          {loading && <p>Uploading...</p>}
          {product.image && (
            <img src={product.image} alt="preview" style={{ width: "100px" }} />
          )}
        </div>

        {/* NAME */}
        <div className="addProductItem">
          <label>Name</label>
          <input type="text" name="name" onChange={handleChange} required />
        </div>

        {/* SLUG */}
        <div className="addProductItem">
          <label>Slug</label>
          <input
            type="text"
            name="slug"
            value={product.slug}
            onChange={handleChange}
          />
        </div>

        {/* PRICE */}
        <div className="addProductItem">
          <label>Price</label>
          <input type="number" name="price" onChange={handleChange} required />
        </div>

        {/* STOCK */}
        <div className="addProductItem">
          <label>Stock</label>
          <input type="number" name="stock" onChange={handleChange} />
        </div>

        {/* CATEGORY */}
        <div className="addProductItem">
          <label>Category</label>
          <input type="text" name="category" onChange={handleChange} />
        </div>

        {/* SUBCATEGORY */}
        <div className="addProductItem">
          <label>Sub Category</label>
          <input type="text" name="subcategory" onChange={handleChange} />
        </div>

        {/* BRAND */}
        <div className="addProductItem">
          <label>Brand</label>
          <input type="text" name="brand" onChange={handleChange} />
        </div>

        {/* SIZES */}
        <div className="addProductItem">
          <label>Sizes</label>
          <input
            type="text"
            onChange={(e) =>
              setProduct({
                ...product,
                sizes: e.target.value.split(",").map((s) => s.trim()),
              })
            }
          />
        </div>

        {/* COLORS */}
        <div className="addProductItem">
          <label>Colors</label>
          <input
            type="text"
            onChange={(e) =>
              setProduct({
                ...product,
                colors: e.target.value.split(",").map((c) => c.trim()),
              })
            }
          />
        </div>

        {/* DISCOUNT */}
        <div className="addProductItem">
          <label>Discount (%)</label>
          <input type="number" name="discount" onChange={handleChange} />
        </div>

        {/* DESCRIPTION */}
        <div className="addProductItem">
          <label>Description</label>
          <textarea name="description" onChange={handleChange} />
        </div>

        {/* SPECIFICATIONS */}
        <div className="addProductItem">
          <label>Specifications</label>

          {product.specifications.map((spec, index) => (
            <div
              key={index}
              style={{ display: "flex", gap: "10px", marginBottom: "8px" }}
            >
              <input
                type="text"
                placeholder="Key"
                value={spec.key}
                onChange={(e) => handleSpecChange(index, "key", e.target.value)}
              />

              <input
                type="text"
                placeholder="Value"
                value={spec.value}
                onChange={(e) =>
                  handleSpecChange(index, "value", e.target.value)
                }
              />

              <button type="button" onClick={() => removeSpecification(index)}>
                ❌
              </button>
            </div>
          ))}

          <button type="button" onClick={addSpecification}>
            ➕ Add Specification
          </button>
        </div>

        {/* STATUS */}
        <div className="addProductItem">
          <label>Status</label>
          <select name="status" onChange={handleChange}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        {/* HOMEPAGE CONTROL */}
        <div className="addProductItem">
          <label>Homepage Control</label>

          <div>
            <input
              type="checkbox"
              checked={product.isFeatured}
              onChange={(e) =>
                setProduct({ ...product, isFeatured: e.target.checked })
              }
            />
            <span> Featured</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isPopular}
              onChange={(e) =>
                setProduct({ ...product, isPopular: e.target.checked })
              }
            />
            <span> Popular</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isTrending}
              onChange={(e) =>
                setProduct({ ...product, isTrending: e.target.checked })
              }
            />
            <span> Trending</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isTopSelling}
              onChange={(e) =>
                setProduct({ ...product, isTopSelling: e.target.checked })
              }
            />
            <span> Top Selling</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isDealsOfDay}
              onChange={(e) =>
                setProduct({ ...product, isDealsOfDay: e.target.checked })
              }
            />
            <span> Deals Of Day</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isBanner}
              onChange={(e) =>
                setProduct({ ...product, isBanner: e.target.checked })
              }
            />
            <span> Banner</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isAd}
              onChange={(e) =>
                setProduct({ ...product, isAd: e.target.checked })
              }
            />
            <span> Ads</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isRecentlyAdded}
              onChange={(e) =>
                setProduct({ ...product, isRecentlyAdded: e.target.checked })
              }
            />
            <span> Recently Added</span>
          </div>

          <div>
            <input
              type="checkbox"
              checked={product.isTopRated}
              onChange={(e) =>
                setProduct({ ...product, isTopRated: e.target.checked })
              }
            />
            <span> Top Rated</span>
          </div>
        </div>

        {/* SUBMIT */}
        <button className="addProductButton" type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Create"}
        </button>
      </form>
    </div>
  );
};

export default NewProduct;
